class BannerCountdown extends HTMLElement {
    constructor() {
        super();
        this.bannerCountDownItems = this.querySelectorAll('.banner_countdown');
        this.arnGlobalBanner = this.closest('arn-global-banner');
        this.setup();
    }

    setup() {

        this.bannerCountDownItems.forEach((val, index, array) => {
            this.enableCountdown(val);
        });
    }

    enableCountdown(bannerDiv) {
        const dateTo = bannerDiv.getAttribute('data-countdown-date-to');
        const timezone = bannerDiv.getAttribute('data-timezone');
        const bckColor = bannerDiv.getAttribute('data-background-color');
        const currentDate = DateUtils.getCurrentDate(timezone);

        let hasSetBannerHeight = false;

        if (dateTo == "" || dateTo < currentDate) {
            bannerDiv.innerHTML = '';
            return true;
        }

        const countDownDate = new Date(dateTo).getTime();

        const t = setInterval(function (arnGlobalBanner) {
            const countdownValues = DateUtils.getCountdown(countDownDate, timezone);

            if (countdownValues.length == 0) {
                clearInterval(t);
                bannerDiv.innerHTML = '';
                bannerDiv.style.backgroundColor = "transparent";
            }

            bannerDiv.innerHTML = countdownValues.join(' : ');
            bannerDiv.style.backgroundColor = bckColor;

            if (arnGlobalBanner && !hasSetBannerHeight) {
                // Set the height of the banner after the countdown is set (on mobile it could make the banner height change)
                arnGlobalBanner.setBannerHeight();
                hasSetBannerHeight = true;
            }

        }.bind(DateUtils.getCountdown, this.arnGlobalBanner), 1000);
    }
}
customElements.define('banner-countdown', BannerCountdown);
